<template lang="pug">
	transition(name="slide", mode="out-in")
		router-view
</template>

<script>
import ManageApply from '@/listing-app/mixins/ManageApply'
export default {
  name: "NextGen",
	mixins: [ManageApply],
  methods: {
    set_outline() {
      document.body.addEventListener("mousedown", function() {
        document.body.classList.add("using-mouse")
      })
      document.body.addEventListener("keydown", function() {
        document.body.classList.remove("using-mouse")
      })
    }
  },
  created() {
    this.set_outline()
	},
	mounted() {
		this.init_apply()
	}
};
</script>


<style lang="scss">
body.using-mouse {
  #next_gen,
  #next_gen * {
    outline: none !important;
  }
}

.app-page {
	margin-top: 2rem;
  box-sizing: border-box;
	color: $mediumGray;
	font-family: $fontFamilyBase;
  font-size: $fontSizeBase;
  -webkit-font-smoothing: antialiased;
  *,
  *:before,
  *:after {
    line-height: 1.5;
    box-sizing: inherit;
  }
}

.next_gen-control {
	transition: opacity 0.25s ease, visibility 0.25s ease;
}
.next_gen-control--hidden {
	opacity: 0 !important;
	visibility: hidden!important;
	pointer-events: none !important;
}
</style>

<style lang="scss" scoped>
.slide-enter-active {
  transition: all 0.25s 0.25s ease;
}
.slide-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-enter,
.slide-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>

